import { ToastService } from '@service/toast/toast.service';
import { Component, Input, ElementRef, ViewChild, NgModule } from '@angular/core';
import { UserService } from '@service/user/user.service';
import { Profile } from '@interface/profile';
import { allowedImageExtensions } from '@configuration/image-definitions';
import { messages } from '@configuration/messages';
import { BonusLevel } from '@model/bonus-level';
import { CompanyProfile } from '@model/company-profile/company-profile';

import { BonusService } from '@service/bonus.service';
import { environment } from '@environments/environment';
import { ScrollService } from '@service/scroll.service';
import { SharedModule } from 'src/app/shared.module';
import { StateService } from '@service/state.service';
import { LoadingService } from '@service/loading.service';
import { filesizeAllowed, getFileExtension } from 'src/app/misc/image-upload-helper';

@Component({
  selector: 'app-profile-header',
  templateUrl: './profile-header.component.html',
  styleUrls: ['./profile-header.component.scss'],
})
export class ProfileHeaderComponent {
  public environment = environment;

  @Input()
  public set profile(p: Profile) {
    if (!p) return;

    this._profile = p;

    if (p instanceof CompanyProfile) {
      this.purposeKeyPrefix = 'COMPANY';
      this.isBusinessProfile = true;
    }

    // get level of user
    if (!this.isBusinessProfile) {
      this.BonusService.getExternalUserLevel(p.id).then((level: BonusLevel) => {
        this.level = level;
      });
    }
  }
  public get profile(): Profile {
    return this._profile;
  }
  private _profile: Profile = null;
  public level: BonusLevel = null;
  public purposeKeyPrefix: 'PROFILE' | 'COMPANY' = 'PROFILE';
  public isBusinessProfile: boolean = false;

  public loading: boolean = false;

  @Input()
  public disabled = false;

  @ViewChild('wallImageInput')
  public wallImageInput: ElementRef;

  @ViewChild('profileImageInput')
  public profileImageInput: ElementRef;

  @Input()
  public editDisabled: boolean = false;

  @Input()
  public containProfileImage: boolean = false;

  constructor(
    private userService: UserService,
    private toastService: ToastService,
    private BonusService: BonusService,
    private ScrollService: ScrollService,
    private StateService: StateService,
    private LoadingService: LoadingService,
  ) {}

  public pressWallImageUploadBtn() {
    this.wallImageInput.nativeElement.click();
  }

  public pressProfileImageUploadBtn() {
    this.profileImageInput.nativeElement.click();
  }

  public uploadProfileImage(imageInput: any, purposekey: string): void {
    if (imageInput.files.length < 1) return;

    if (filesizeAllowed(imageInput.files)) {
      this.LoadingService.startLoad();
      const extension = getFileExtension(imageInput.files[0].name).toLowerCase();

      if (!allowedImageExtensions.includes(extension)) {
        this.toastService.showError('Bilder mit dieser Dateiendung können nicht hochgeladen werden.');
        this.LoadingService.stopLoad();
        return;
      }

      const file: File = imageInput.files[0];

      const formData: FormData = new FormData();
      formData.append('images[0][purpose_key]', purposekey);
      formData.append('images[0][image]', file);

      this.userService
        .uploadImage(
          formData,
          purposekey as
            | 'COMPANY_PRODUCT'
            | 'COMPANY_CERTIFICATE'
            | 'PROFILE_CERTIFICATE'
            | 'PROFILE_IMAGE'
            | 'COMPANY_IMAGE'
            | 'PROFILE_WALL_IMAGE'
            | 'COMPANY_WALL_IMAGE',
        )
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.LoadingService.stopLoad();
        });
    } else {
      this.toastService.showError(messages.imageUploadMaxSize);
    }
  }

  public deleteProfileImage() {
    this.loading = true;

    let promise: Promise<any>;
    if (this.isBusinessProfile)
      promise = this.userService.deleteCompanyProfileImage(this.profile.profileImage.image.id);
    else promise = this.userService.deleteProfileImage();

    promise
      .catch((e) => {
        console.log(e);
        this.toastService.showError(messages.undefinederror);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public deleteWallImage() {
    this.loading = true;

    let promise: Promise<any>;
    if (this.isBusinessProfile)
      promise = this.userService.deleteCompanyProfileImage(this.profile.profileWallImage.image.id);
    else promise = this.userService.deleteWallImage();

    promise
      .catch((e) => {
        console.log(e);
        this.toastService.showError(messages.undefinederror);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public gotoBonusFaq() {
    this.StateService.goto('/boni/faq').then(() => {
      setTimeout(() => {
        this.ScrollService.scrollToSelector('#leveloverview', 0, true);
      }, 400);
    });
  }
}

@NgModule({
  declarations: [ProfileHeaderComponent],
  imports: [SharedModule],
  exports: [ProfileHeaderComponent, SharedModule],
})
export class ProfileHeaderComponentModule {}
